import { render, staticRenderFns } from "./AppTour.vue?vue&type=template&id=4bc2c89d&"
import script from "./AppTour.vue?vue&type=script&lang=js&"
export * from "./AppTour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports